@import '../../../globals/main.scss';

pn-app-banner {
  .pn-app-banner__wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;

    background-color: $gray50;
    padding: 1rem;
    margin: 0 auto;
  }

  .pn-app-banner__sticky {
    position: relative;

    top: 0;
    width: 100%;

    z-index: 999;
  }

  .icon-close {
    &:hover {
      cursor: pointer;
    }
  }

  .pn-app-banner__icon {
    height: 3.2rem;
  }

  .pn-app-banner__text {
    font-size: 1.2rem;
    line-height: 1;

    span {
      font-weight: 600;
    }
  }

  .pn-app-banner__cta {
    margin-left: auto;
  }

  &[data-is-closed='true'] {
    display: none;
  }
}
